import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './index.css';
import "@fontsource/roboto/latin-400.css"
import "@fontsource/roboto/latin-500.css"

import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';
//import matrixLogo from './assets/logo-white.svg'
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <div className="tw-justify-center tw-h-full">  
      <App />
    </div>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
